module.exports = __webpack_public_path__ + "static/img/cps_03.c63e9ec.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zh/cps_03.jpg
// module id = BcKR
// module chunks = 0